import type { AnchorHTMLAttributes } from 'react';

import { newsStyles } from '../../styles';

export type ExternalLinkProps = Omit<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  'target' | 'rel'
>;

export function ExternalLink({ className, ...props }: ExternalLinkProps) {
  const styles = newsStyles();

  return (
    <a
      className={styles.primary({ className: styles.clickable({ className }) })}
      target="_blank"
      rel="noreferrer"
      {...props}
    />
  );
}
